import React from 'react';
import './ErrorPage.scss';
import myHospital from '../../images/myHospital.PNG';
import { authorizationLink } from "../utils/config"

export const loginHandler = () => {
    window.location.replace(`${authorizationLink}?redirect=${encodeURIComponent(window.location.href)}`);
}

const Unauthorized401 = () => {

    return (
        <section className="error-page unauthorized">
            <div className="description">
                <p className="gray-text">Błąd</p>
                <div className="container">
                    <p className="code">#401</p>
                    <p className="break-text">
                        <span>Brak</span>
                        <span>autoryzacji</span>
                    </p>
                </div>
                <p className="uppercase-text">Aplikacja wymaga zalogowania w serwisie myHospital!</p>
                <p className="text">W celu uruchomienia aplikacji należy zalogować się do serwisu myHospital.</p>
                <p className="text">Po zalogowaniu do serwisu aplikacja przeładuje się automatycznie.</p>
                <button onClick={loginHandler} className="btn btn-large">
                    myHospital
                </button>
                <p className="text padding">W razie pytań prosimy o kontakt:</p>
                <address className="address">
                    <dl className="contact">
                        <dt className="contact__list">
                            <i className="material-icons">mail_outline</i> <a className="list__item" href="mailto:sga@sga.waw.pl">sga@sga.waw.pl</a>
                        </dt>
                        <dt className="contact__list">
                            <i className="material-icons">phone</i> <a className="list__item" href="tel:81-534-21-05">(81) 534 21 05</a>
                        </dt>
                    </dl>
                </address>
            </div>
            <button onClick={loginHandler} className="btn btn-img">
                <img className="img" src={myHospital} alt="myHospital logo" />
            </button>
        </section>
    );
}

export default Unauthorized401;